import React from 'react'

import PropTypes from 'prop-types'

import './store-banner.css'

const StoreBanner = (props) => {
  return (
    <div className="store-banner-store-banner">
      <a
        href={props.url1}
        target="_blank"
        rel="noreferrer noopener"
      >
      <img
        alt={props.imageAlt1}
        src={props.imageSrc1}
        className="store-banner-image1"
      />
      </a>
      <a
        href={props.url}
        target="_blank"
        rel="noreferrer noopener"
      >
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        className="store-banner-image2"
      />
      </a>
    </div>
  )
}

StoreBanner.defaultProps = {
  imageSrc: '/app-store-badge-200h.png',
  imageAlt1: 'image',
  url: "https://apps.apple.com/us/app/ismailishq/id6740751722",
  imageSrc1: '/google-play-badge-200h.png',
  imageAlt: 'image',
  url1: "https://play.google.com/store/apps/details?id=com.ismailishqapp",
}

StoreBanner.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageAlt: PropTypes.string,
}

export default StoreBanner
